/* unplugin-vue-components disabled */import { render } from "./AddIos.vue?vue&type=template&id=1af03fbe"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__